/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
  REQUEST_METRIC,
  FETCH_METRIC_SUCCESS,
  FETCH_METRIC_FAILURE,
} from './actionTypes'

const initialState = {
  items: {},
}

const metrics = (state = initialState, action) => {
  let updatedItems = {}
  let newMetrics = {}
  switch (action.type) {
    case REQUEST_METRIC:
      newMetrics = Object.assign({}, state.items)
      action.data.forEach((metricId) => {
        newMetrics[metricId] = newMetrics[metricId] || {}
        newMetrics[metricId].isFetching = true
      })
      updatedItems = Object.assign({}, state.items, newMetrics)
      return Object.assign({}, state, {
        items: Object.assign({}, state.items, updatedItems)
      });
    case FETCH_METRIC_SUCCESS:
      newMetrics = Object.assign({}, state.items)
      action.data.forEach((data) => {
        newMetrics[data.metricType] = newMetrics[data.metricType] || {}
        newMetrics[data.metricType].id = data.metricType
        newMetrics[data.metricType].isFetching = false
        if (!data.error) {
          newMetrics[data.metricType].samples = data.items || []
          newMetrics[data.metricType].avg = data.avg
          newMetrics[data.metricType].max = data.max
          newMetrics[data.metricType].min = data.min
          newMetrics[data.metricType].ciName = data.ciName;
        } else {
          newMetrics[data.metricType].error = data.error
        }
      })
      updatedItems = Object.assign({}, state.items, newMetrics)
      const updatedState = Object.assign({}, state, {
        items: Object.assign({}, state.items, updatedItems)
      });
      return updatedState;
  case FETCH_METRIC_FAILURE:
    return Object.assign({}, state, {
      errorMessage: action.errorMessage,
    });

  default:
    return state
  }
}

export default metrics;
